import { Box } from "@chakra-ui/react";
import Footer from "./footer";
import Navbar from "./navbar";
const PublicLayout = ({ children, color, bg, register = true, type }) => {
  return (
    <Box
      w="100%"
      // h="100%"
      // minH="100vh"
      className="public"
      overflowX="hidden"
      justifyContent="space-between"
      bg="#E9E2DB"
      sx={{
        backgroundImage:
          "radial-gradient(ellipse 120% 80% at 85% 5%, rgba(106, 30, 30, 0.07) 0%, transparent 52%), radial-gradient(ellipse 100% 70% at 5% 95%, rgba(74, 15, 31, 0.06) 0%, transparent 48%), radial-gradient(ellipse 90% 60% at 50% 50%, rgba(216, 206, 195, 0.45) 0%, transparent 55%)",
      }}
    >
      <Box h="100px" w="100%">
        <Navbar color={color} bg={bg} register={register} type={type} />
      </Box>
      {children}

      {/* <Footer /> */}
    </Box>
  );
};

export default PublicLayout;
